import React from 'react'
import NoPadH3 from '../../titles/NoPadH3'
import Divider from '../../Divider'
import { Button } from 'react-bootstrap'

const goals = [
  {id:1, name: "Goal 01", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"27-06-2022", deadline: "21-08-2022", reached: false},
  {id:2, name: "Goal 02", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"27-06-2022", deadline: "21-08-2022", reached: false},
  {id:3, name: "Goal 03", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"27-06-2022", deadline: "21-08-2022", reached: false},
  {id:4, name: "Goal 04", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"27-06-2022", deadline: "21-08-2022", reached: false},
  {id:5, name: "Goal 05", desc: "Minim esse officia laborum veniam minim mollit.", createdAt:"27-06-2022", deadline: "21-08-2022", reached: false},
]

const InProgress = () => {
  return (<>
    <NoPadH3>In Progress</NoPadH3>
    <Divider></Divider>
    <div className='d-flex flex-wrap p-2'>
      {goals.map(g => <div key={g.id} style={{maxWidth:"240px", boxShadow:"2px 2px 12px .2px turquoise"}} className='p-4 m-2 rounded'>
        <p className='fs-3'>{g.name}</p>
        <p>{g.desc}</p>
        <p className='mt-3'>Created: {g.createdAt}</p>
        <p>Deadline: {g.deadline}</p>
        <Button variant='outline-warning' className='w-100'>Edit</Button>
        <Button className='w-100 mt-3' variant='outline-danger'>Remove</Button>
      </div>)}
    </div>
  </>)
}

export default InProgress